const SideBarMenuConfig = {

  dashboard: {
    label: "Dashboard",
    path: "/dashboard"
  },

  theory: {
    label: "Teoria",
    isExpandable: false,
    authOnly: true,
    children: [
      {
        label: "Wyniki testów",   // ⭐ ZMIANA TU
        path: "/charts"
      }
    ]
  },

  practice: {
    label: "Praktyka",
    children: [
      {
        label: "Zadania",
        authOnly: true,
        type: "exercises",
        isExpandable: false,
      },
      {
        label: "Arkusze egzaminacyjne",
        type: "qualifications"
      },
      {
        label: "Statystyki realizacji arkuszy",
        path: "/practicestats",
        authOnly: true
      },
      {
      label: "Narzędzia",
      isExpandable: false,
      authOnly: true,
      children: [
        {
          label: "Codepen JS",
          path: "https://codepen.io/pen/",
          external: true
        },
        {
          label: "Python Online Interpreter",
          path: "https://pythononline.net/",
          external: true
        },
        {
          label: "CodeSandbox",
          path: "https://codesandbox.io/",
          external: true
        }
      ]
    }
    ]
  },
  vmportal: {
    label: "VM Portal",
    path: "https://rhev.zspw.pl/ovirt-engine/sso/login.html",
    external: true,
    authOnly: true
  },
  analysis: {
    label: "Analiza egzaminów",
    path: "/examanalysis",
    authOnly: true
  },

  resources: {
    label: "Inne",
    isExpandable: false,
    authOnly: true,
    children: [
      {
        label: "Linki",
        path: "/resources",
      }
    ]
  }

};

export default SideBarMenuConfig;